import { BrowserRouter, Routes, Route } from "react-router-dom";
import { HelmetProvider } from "react-helmet-async";
import Header from "./components/Header";
import Body from "./components/Body";
import Energiamargis from "./components/Energiamargis";
function App() {
  return (
    <HelmetProvider>
    <BrowserRouter>
      <div className="page-wrapper">
        <Header />
        <Routes>
          <Route path="/" element={<Body />} />
          <Route path="/energiamargis" element={<Energiamargis />} />
        </Routes>
      </div>
    </BrowserRouter>
    </HelmetProvider>
  );
}

export default App;
